import Primary from './Primary';
import Secondary from './Secondary';
import Tertiary from './Tertiary';
import ThirdParty from './ThirdParty';
import Destructive from './Destructive';
import DestructiveGhost from './DestructiveGhost';
import DeprecatedPrimary from './DeprecatedPrimaryButton';

export default {
  Primary,
  DeprecatedPrimary,
  Secondary,
  Tertiary,
  ThirdParty,
  Destructive,
  DestructiveGhost,
};

export const PrimaryButton = Primary;
export const DeprecatedPrimaryButton = DeprecatedPrimary;
export const SecondaryButton = Secondary;
export const TertiaryButton = Tertiary;
export const ThirdPartyButton = ThirdParty;
export const DestructiveButton = Destructive;
export const DestructiveGhostButton = DestructiveGhost;
export { default as ButtonIcon } from './ButtonIcon';
